import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormGroup,
    Validators,
    FormControl,
    ReactiveFormsModule,
    AbstractControl,
    ValidationErrors,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { EstudanteService } from "app/service/estudante/estudante.service";
import { Router } from "@angular/router";
import { ComplementoEstudante } from "models/complemento-estudante";
import { Contato } from "models/contato";
import { Endereco } from "models/endereco";
import { ToastrService } from "ngx-toastr";
@Component({
    selector: "app-complemento-estudante",
    templateUrl: "./complemento-estudante.component.html",
    styleUrls: ["./complemento-estudante.component.scss"],
})
export class ComplementoEstudanteComponent implements OnInit {
    formCadastroComplemento: FormGroup;
    estudanteId: number;
    estado = [
        { nome: "Acre", sigla: "AC" },
        { nome: "Alagoas", sigla: "AL" },
        { nome: "Amapá", sigla: "AP" },
        { nome: "Amazonas", sigla: "AM" },
        { nome: "Bahia", sigla: "BA" },
        { nome: "Ceará", sigla: "CE" },
        { nome: "Distrito Federal", sigla: "DF" },
        { nome: "Espírito Santo", sigla: "ES" },
        { nome: "Goiás", sigla: "GO" },
        { nome: "Maranhão", sigla: "MA" },
        { nome: "Mato Grosso", sigla: "MT" },
        { nome: "Mato Grosso do Sul", sigla: "MS" },
        { nome: "Minas Gerais", sigla: "MG" },
        { nome: "Pará", sigla: "PA" },
        { nome: "Paraíba", sigla: "PB" },
        { nome: "Paraná", sigla: "PR" },
        { nome: "Pernambuco", sigla: "PE" },
        { nome: "Piauí", sigla: "PI" },
        { nome: "Rio de Janeiro", sigla: "RJ" },
        { nome: "Rio Grande do Norte", sigla: "RN" },
        { nome: "Rio Grande do Sul", sigla: "RS" },
        { nome: "Rondônia", sigla: "RO" },
        { nome: "Roraima", sigla: "RR" },
        { nome: "Santa Catarina", sigla: "SC" },
        { nome: "São Paulo", sigla: "SP" },
        { nome: "Sergipe", sigla: "SE" },
        { nome: "Tocantins", sigla: "TO" },
    ];

    constructor(
        private fb: FormBuilder,
        private estudanteService: EstudanteService,
        private route: ActivatedRoute,
        private router: Router,
        private toasterService: ToastrService,
    ) {}

    ngOnInit(): void {
        this.formCadastroComplemento = this.fb.group({
            telefonePessoal: new FormControl("", Validators.required),
            telefoneFixo: new FormControl(""),
            nacionalidade: new FormControl("", Validators.required),
            naturalidade: new FormControl("", Validators.required),
            logradouro: new FormControl("", Validators.required),
            numero: new FormControl("", Validators.required),
            complemento: new FormControl(""),
            bairro: new FormControl("", Validators.required),
            cidade: new FormControl("", Validators.required),
            uf: new FormControl("", Validators.required),
            cep: new FormControl("", Validators.required),
        });

        this.estudanteId = Number(this.route.snapshot.paramMap.get("id"));
    }

    onSubmit(): void {
        if (this.formCadastroComplemento.invalid) {
            this.formCadastroComplemento.markAllAsTouched();
            // alert('Necessário está logado para realizar o complemento do cadastro do estudante')
            return;
        }
        if (this.formCadastroComplemento.valid) {
            this.persisteDadosComplementoEstudante();
        }
    }

    onVoltar() {
        this.router.navigate(["/login"]);
    }

    persisteDadosComplementoEstudante() {
        const payload: ComplementoEstudante = this.preparaPayload();
        this.estudanteService.salvarComplementoEstudante(this.estudanteId, payload).subscribe({
            next: () => {
                this.formCadastroComplemento.reset();
                this.toasterService.success("Cadastro confirmado com sucesso!");
                this.redirectTo("/home");
            },
            error: err => {
                //console.error("Erro ao salvar:", err);
                const campoCompostoDTO = err.error[0].error;
                const campoSimplesDTO = campoCompostoDTO.split(".").pop();
                if (campoSimplesDTO == "naturalidade") {
                    this.toasterService.warning("O campo " + err.error[0].message);
                    // alert("O campo "+err.error[0].message);
                } else {
                    alert("Erro ao salvar o cadastro, verifique sua conexão de rede");
                }
            },
        });
    }

    preparaPayload(): ComplementoEstudante {
        const form = this.formCadastroComplemento.value;

        const payload: ComplementoEstudante = new ComplementoEstudante();

        payload.contato = new Contato();
        payload.contato.telefoneFixo = form.telefoneFixo;
        payload.contato.telefonePessoal = form.telefonePessoal;

        payload.nacionalidade = form.nacionalidade;
        payload.naturalidade = form.naturalidade;

        payload.endereco = new Endereco();
        payload.endereco.uf = form.uf;
        payload.endereco.cep = form.cep;
        payload.endereco.cidade = form.cidade;
        payload.endereco.bairro = form.bairro;
        payload.endereco.complemento = form.complemento;
        payload.endereco.numero = form.numero;
        payload.endereco.logradouro = form.logradouro;

        return payload;
    }

    redirectTo(uri: string) {
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => this.router.navigate([uri]));
    }
}
